import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const SeniorLibrary = () => {
  useEffect(() => {
    document.title = "Senior Library -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home - Click Here</Link>
          </li>
          <li>TAFS Library </li>
          <li>Senior Library</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Senior Library </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library1.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library1.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library2.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library2.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library3.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library3.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library4.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library4.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
            <div className="col-lg-3">
              <LazyLoad>
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://webapi.entab.info/api/image/TAFS/public/Images/Library5.jpg"
                >
                  <img
                    src="https://webapi.entab.info/api/image/TAFS/public/Images/Library5.jpg"
                    className="schoollib img-fluid"
                    alt="TAFS"
                  />
                </a>
              </LazyLoad>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <ul className="list">
                <li style={{ background: "blue" }}>
                  <a
                    style={{ color: "white" }}
                    href="http://216.48.176.181:81/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b>Click here to login to the school library</b>
                  </a>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/Swadeshisec.pdf"
                    target="_blank"
                  >
                    Swadeshi For a Self-Reliant India Secondary Stage - Click
                    Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/Swadeshimiddle.pdf"
                    target="_blank"
                  >
                    Swadeshi - Vocal for Local - Middle Stage - Click Here
                  </Link>
                </li>
                <li>
                  <Link to="https://ndl.education.gov.in/home" target="_blank">
                    Rashtriya e-Pustakalaya - Click Here
                  </Link>
                </li>
                <li>
                  <Link to="https://www.ndl.gov.in/" target="_blank">
                    National Digital Library
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/newArrival_wrinkle_in_time.pdf"
                    target="_blank"
                  >
                    New Arrivals 2025 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book1.pdf"
                    target="_blank"
                  >
                    From Library's Desk - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book2.pdf"
                    target="_blank"
                  >
                    Digital Reading - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book3.pdf"
                    target="_blank"
                  >
                    Comic Book - Click Here
                  </Link>
                </li>
                {/* <li><Link to="https://www.youtube.com/watch?v=JhIw8ch4A9M&t=4s" target="_blank">  Mathematician Srinivasa Ramanujan- Biographical Movie  - Click Here</Link> </li>
                <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book4.pdf" target="_blank">  Reading Challenge: Quarantine Productive  - Click Here</Link> </li>
                <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book5.pdf" target="_blank">  Reading Challenge: Eoin Colfer Collection  - Click Here</Link> </li>
                <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book6.pdf" target="_blank">  Presentation On Digital Story Telling  - Click Here</Link> </li>
                <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book7.pdf" target="_blank">  Cbse Question Bank For Class X & XII  - Click Here</Link> </li>
                <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book8.pdf" target="_blank">  New Arrival Books Nov 2024  - Click Here</Link> </li>
                 <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book9.pdf" target="_blank">  Book Of The Month  - Click Here</Link> </li> */}
              </ul>
              <h6>Our Student Authors</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/VIDITBALHARA-25.pdf"
                    target="_blank"
                  >
                    VIDIT BALHARA, VII B, 2025-26 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/MAHIMANMANHAS-25.pdf"
                    target="_blank"
                  >
                    MAHIMAN MANHAS, VII B, 2025-26 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/SIFFATKAUR-24.pdf"
                    target="_blank"
                  >
                    SIFFAT KAUR, VIII E, 2023-24 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book10.pdf"
                    target="_blank"
                  >
                    Aadya Upadhyay, VIII D, 2023-24 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book11.pdf"
                    target="_blank"
                  >
                    Amhika Sahu, VII B, 2023-24 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book12.pdf"
                    target="_blank"
                  >
                    Yashmita VII F, 2024-25 - Click Here
                  </Link>
                </li>
              </ul>
              <h6>E-books </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book13.pdf"
                    target="_blank"
                  >
                    Harry Potter - Book 1 : Harry Potter And The Philosophers
                    Stone - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book14.pdf"
                    target="_blank"
                  >
                    Harry Porter Book 2 : Harry Porter And The Chamber Of
                    Secrets - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book15.pdf"
                    target="_blank"
                  >
                    Harry Porter Book 3: Harry Porter And The Prisoner Of
                    Azkaban - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book16.pdf"
                    target="_blank"
                  >
                    Harry Potter Book 4: Harry Porter And The Goblet Of Fire -
                    Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book17.pdf"
                    target="_blank"
                  >
                    Harry Porter Book 5: Harry Porter And The Order Of The
                    Phoenix - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book18.pdf"
                    target="_blank"
                  >
                    Harry Potter Book 6: Harry Porter And The Half-blood Prince
                    - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book19.pdf"
                    target="_blank"
                  >
                    Harry Potter Book 7: Harry Potter And The Deathly Hallows -
                    Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book20.pdf"
                    target="_blank"
                  >
                    Harry Potter And The Curse Child Part 1 & 2 - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book21.pdf"
                    target="_blank"
                  >
                    Fantastic Beasts - Click Here
                  </Link>
                </li>
              </ul>
              <h6>Wimpy Kid Series </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book22.pdf"
                    target="_blank"
                  >
                    Diary Of A Wimpy Kid - Rodrick Rules - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book23.pdf"
                    target="_blank"
                  >
                    Diary Of A Wimpy Kid - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book24.pdf"
                    target="_blank"
                  >
                    Diary Of A Wimpy Kid_ Double Down - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book25.pdf"
                    target="_blank"
                  >
                    Diary Of A Wimpy Kid; The Ugly Truth - Click Here
                  </Link>
                </li>
              </ul>
              <h6>Percy Jackson Series By Rick Riordan </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book26.pdf"
                    target="_blank"
                  >
                    Lightning Thief - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book27.pdf"
                    target="_blank"
                  >
                    The Sea Of Monsters - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book28.pdf"
                    target="_blank"
                  >
                    Battle Of Labrinth - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book29.pdf"
                    target="_blank"
                  >
                    Last Olympian - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book30.pdf"
                    target="_blank"
                  >
                    The Lost Hero - Click Here
                  </Link>
                </li>
              </ul>
              <h6> RL Stine: Give Yourself Goosebumps </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book31.pdf"
                    target="_blank"
                  >
                    Book I - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book32.pdf"
                    target="_blank"
                  >
                    Book II - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book33.pdf"
                    target="_blank"
                  >
                    Book III - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book34.pdf"
                    target="_blank"
                  >
                    Book IV - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book35.pdf"
                    target="_blank"
                  >
                    Book V - Click Here
                  </Link>
                </li>
              </ul>
              <h6> Mahatma Gandhi </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book36.pdf"
                    target="_blank"
                  >
                    An Autobiography Or My Experiments With Truth - Click Here
                  </Link>
                </li>
              </ul>
              <h6> Favourite Reads </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book37.pdf"
                    target="_blank"
                  >
                    Classes VI - VII - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book38.pdf"
                    target="_blank"
                  >
                    Study / Exam Tips - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book39.pdf"
                    target="_blank"
                  >
                    Motivational / Inspirational - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book40.pdf"
                    target="_blank"
                  >
                    Favourite Reads - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book41.pdf"
                    target="_blank"
                  >
                    Competitive Exam Books - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book42.pdf"
                    target="_blank"
                  >
                    Hindi Collections - Click Here
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <h6>Presentation On Books </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book43.pdf"
                    target="_blank"
                  >
                    A Place Called Here - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book44.pdf"
                    target="_blank"
                  >
                    Dork Diaries - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book45.pdf"
                    target="_blank"
                  >
                    Dork Diaries - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book46.pdf"
                    target="_blank"
                  >
                    The Land Of Stories - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book47.pdf"
                    target="_blank"
                  >
                    The Panchatantra - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book48.pdf"
                    target="_blank"
                  >
                    Diary Of Wimpy Kid - Click Here
                  </Link>
                </li>
              </ul>
              <h6>FAVOURITE AUTHORS </h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book49.pdf"
                    target="_blank"
                  >
                    Salman Rushdie - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book50.pdf"
                    target="_blank"
                  >
                    Edith Pattou - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book51.pdf"
                    target="_blank"
                  >
                    Anita Desai - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book52.pdf"
                    target="_blank"
                  >
                    Paulo Coelho - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book53.pdf"
                    target="_blank"
                  >
                    Rabindranath Tagore - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book54.pdf"
                    target="_blank"
                  >
                    Dr APJ Abdul Kalam - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book55.pdf"
                    target="_blank"
                  >
                    Washington Irving - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book56.pdf"
                    target="_blank"
                  >
                    Nelson Demille - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book57.pdf"
                    target="_blank"
                  >
                    Agatha Christie - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book58.pdf"
                    target="_blank"
                  >
                    Jeff Kinney - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book59.pdf"
                    target="_blank"
                  >
                    RL Stine - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book60.pdf"
                    target="_blank"
                  >
                    Sudha Murty - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book61.pdf"
                    target="_blank"
                  >
                    Anita Krishnan - Click Here
                  </Link>
                </li>
              </ul>
              <h6>Library Activities </h6>
              <p>Book Reviews </p>
              <ul className="list">
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book62.pdf"
                    target="_blank"
                  >
                    Class VIII A - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book63.pdf"
                    target="_blank"
                  >
                    class VIII B - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book64.pdf"
                    target="_blank"
                  >
                    Class VIII C - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book65.pdf"
                    target="_blank"
                  >
                    Class VIII D - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book66.pdf"
                    target="_blank"
                  >
                    Class VIII E - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book67.pdf"
                    target="_blank"
                  >
                    Class IX A - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book68.pdf"
                    target="_blank"
                  >
                    Class IX B - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book69.pdf"
                    target="_blank"
                  >
                    Class IX E - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book70.pdf"
                    target="_blank"
                  >
                    Class Xi B - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book71.pdf"
                    target="_blank"
                  >
                    Class Xi D - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book72.pdf"
                    target="_blank"
                  >
                    Class Xi E - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book73.pdf"
                    target="_blank"
                  >
                    Bookmark Activity - Class Vi D - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book74.pdf"
                    target="_blank"
                  >
                    Book Cover Pages - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book75.pdf"
                    target="_blank"
                  >
                    Class Viii D - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book76.pdf"
                    target="_blank"
                  >
                    Class IX A - Click Here
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://webapi.entab.info/api/image/TAFS/public/pdf/book77.pdf"
                    target="_blank"
                  >
                    Class IX B - Click Here
                  </Link>
                </li>
              </ul>
              {/* <h6>Students Foyer </h6>
                        <ul className="list"> 
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book78.pdf" target="_blank">   Ppt On Experience In Library - Click Here </Link></li>
                        <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/book79.pdf" target="_blank">   Stories: Adventure Of Three Musketeer - Click Here </Link></li>
                </ul> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SeniorLibrary;
